//@ts-ignore
import { ApiClient } from "../../lib/ApiClient";
import { useGenericSWR } from "../../lib/useGenericSWR";
import { SwrOptions } from '../../lib/useGenericSWR.interfaces';

const apiEndpoint = 'api/v1/external/MeterAttribute';

const apiClient = new ApiClient();
apiClient.getObjectName = () => {
    return "Meter Attribute";
};

const useMeterAttributes = (
    accountId: number | null | undefined,
    serialNo: string | null,
    uom: string,
    swrOptions = {}
) => {
    // SWR will prevent duplicate requests
    // It will also maintain data state as long as your are using the same urls for your requests
    const params = new URLSearchParams();
    
    if (accountId) {
        params.append('accountId', accountId.toString());
    }

    if (serialNo) {
        params.append('serialNo', serialNo);
    }
    if (uom) {
        params.append('uom', uom);
    }

    const url = apiEndpoint + "?" + params.toString();
    return useGenericSWR(
        (accountId === null || serialNo === "none") ? "" : url,
        apiClient,
        { ...swrOptions as SwrOptions }
    );
};


export {
    useMeterAttributes
};